import "./scss/style.scss";
import "./js/lib/utils";
import Header from "./js/template-parts/common/header";
import ModulesLoader from "./js/modules-loader";
import Barba from "./js/lib/barba";
import Cookies from "./js/template-parts/popups/cookies";

// Load objects
window.objectsLoaded = false;

// Load objects
document.addEventListener("DOMContentLoaded", () => {
  if (window.objectsLoaded === false) {
    // Header
    window.header = new Header();

    // Cookies banner
    window.cookies = new Cookies();
  }
});

window.addEventListener("load", () => {
  if (window.objectsLoaded === false) {
    window.captchaLoaded = false;

    // Modules loader
    window.modulesLoader = new ModulesLoader();
    window.modulesLoader.loadModules();

    // Animations
    import(/* webpackChunkName: "library-scrollmagic" */ "scrollmagic").then(
      ({ default: ScrollMagic }) => {
        window.setAnimationScenes(new ScrollMagic.Controller());
      }
    );

    // BarbaJS
    window.barba = new Barba();

    window.objectsLoaded = true;
  }
});
